<template>
  <div class="wrap">
    <div v-if="!title" class="logo"></div>
    <div v-if="banner" class="banner"></div>
    <div class="box">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      default: ''
    },
    banner: {
      default: true
    }
  }
};
</script>

<style lang="scss">
@media screen and (min-width: $mimViewWidth) {
  @import "@/assets/scss/components/Wrap.scss";
}
@media screen and (max-width: $maxViewWidth) {
  @import "@/assets/scss/components/m/Wrap.scss";
}
</style>
